import config from 'config'

/* Relative paths in the app */
export const rootPath = '/activity'

export const activityPath = '/activity'

export const accountsPath = '/activity/accounts'

export const engagementPath = '/engagement'

export const conversationsPath = '/conversations'

export const accountPath = (accountId: string | number) => `/activity/accounts/${accountId}`

export const contactPath = (contactId: string | number) => `/activity/contacts/${contactId}`

export const insightPath = (insightId: string | number) => `/activity/insights/${insightId}`

export const conversationPath = (conversationId: string | number | undefined) =>
  `/conversations/${conversationId}`

/* Absolute urls in the app */
export const homeUrl = `${config.BASE_URL}${rootPath}`

export const accountsUrl = `${config.BASE_URL}${accountsPath}`

export const engagementUrl = `${config.BASE_URL}${engagementPath}`

export const conversationsUrl = `${config.BASE_URL}${conversationsPath}`

export const notificationSettingsUrl = `${config.BASE_URL}/settings2/notifications?tab=activity`

export const accountUrl = (accountId: string | number) =>
  `${config.BASE_URL}${accountPath(accountId)}`

export const contactUrl = (contactId: string | number) =>
  `${config.BASE_URL}${contactPath(contactId)}`

export const insightUrl = (insightId: string | number) =>
  `${config.BASE_URL}${insightPath(insightId)}`

export const conversationUrl = (conversationId: string | number | undefined) =>
  `${config.BASE_URL}${conversationPath(conversationId)}`

/* Other external urls */
export const visitorUrl = (visitorId: string | number | undefined) =>
  `${config.BASE_URL}/conversations/visitors/${visitorId}`

export const salesforceIntegrationUrl = `${config.BASE_URL}/settings/setup/salesforce`
